import type { Dispatch } from 'redux';
import { createAction, createSlice } from '@reduxjs/toolkit';

import type { ContractVehicle } from './../lib/types';
import { contractVehicleApi } from './../lib/api';
import type { AppState } from './redux';

export const SET_CONTRACT_VEHICLE = 'vehicles/contractVehicle/set';
export const UPDATE_CONTRACT_VEHICLE = 'vehicles/contractVehicle/update';
export const CLEAN_CONTRACT_VEHICLE = 'vehicles/contractVehicle/clean';

export type ContractVehicleState = ContractVehicle | null;

const initialState: ContractVehicleState = null;

const setContractVehicleAction = createAction<ContractVehicle>(
  SET_CONTRACT_VEHICLE
);
const updateContractVehicleAction = createAction<ContractVehicle>(
  UPDATE_CONTRACT_VEHICLE
);
const cleanContractVehicleAction = createAction(CLEAN_CONTRACT_VEHICLE);

const contractVehicleSlice = createSlice({
  name: 'contractVehicle',
  initialState: initialState as ContractVehicleState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(setContractVehicleAction, (_state, { payload }) => payload)
      .addCase(updateContractVehicleAction, (_state, { payload }) => payload)
      .addCase(cleanContractVehicleAction, () => null);
  }
});

export const contractVehicleActions = {
  set: setContractVehicleAction,
  update: updateContractVehicleAction,
  clean: cleanContractVehicleAction
};

export const addContractVehicle = (contractVehicle: ContractVehicle) => async (
  dispatch: Dispatch
): Promise<void> => {
  const payload = await contractVehicleApi.addContractVehicle(contractVehicle);
  dispatch(contractVehicleActions.set(payload));
};

export const updateContractVehicle = (contractVehicle: ContractVehicle) => async (
  dispatch: Dispatch
): Promise<void> => {
  const updated = await contractVehicleApi.updateContractVehicle(
    contractVehicle
  );
  dispatch(contractVehicleActions.update({ ...updated }));
};

export const fetchContractVehicle = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  let contractVehicle = await contractVehicleApi.fetchContractVehicle(id);
  dispatch(contractVehicleActions.set({ ...contractVehicle }));
};

export const cleanContractVehicle = () => (dispatch: Dispatch) =>
  dispatch(contractVehicleActions.clean());

export default contractVehicleSlice.reducer;
